<template>
  <div class="container" v-loading="loading">
    <div class="my-3">
      <b-card class="script-details">
        <template slot="header">
          <div class="pay-summary">
            <ul class="list-unstyled">
              <li>
                <span>{{lang.label.startDate}}</span>
                <span class="mt-1">{{dateFormat(fromDate)}}</span>
              </li>
              <li>
                <span>{{lang.label.endDate}}</span>
                <span class="mt-1">{{dateFormat(toDate)}}</span>
              </li>
              <li>
                <span>{{lang.label.noScriptPaid}}</span>
                <span class="mt-1">{{paymentDetails.noOfScriptsPaid}}</span>
              </li>
              <li>
                <span>{{lang.label.lastPaymentDate}}</span>
                <span class="mt-1">{{dateFormat(paymentDetails.lastPaymentDate)}}</span>
              </li>
              <li>
                <span>{{lang.label.paymentStatus}}</span>
                <span class="mt-1">{{paymentDetails.status}}</span>
              </li>
              <li>
                <span>{{lang.label.openingBalance}}</span>
                <span class="mt-1">R {{paymentDetails.openingBalance}}</span>
              </li>
              <li>
                <span>{{lang.label.closingBalance}}</span>
                <span class="mt-1">R {{paymentDetails.closingBalance}}</span>
              </li>
            </ul>
          </div>
        </template>
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <b-form @submit.stop.prevent="passes(onSubmit)">
            <div class="row">
              <div class="col-md-12">
                <h6 class="heading-title primary-text">{{lang.label.filter}}</h6>
                <span v-if="noDateSelected" style="color: red">{{lang.label.selectDates}}</span>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8 input-section">
                    <div class="row">
                      <div class="col-md-12 col-lg-10 col-xl-8 pr-md-0">
                        <div class="row inputs">
                          <div class="col-md-4">
                            <b-form-group>
                              <label class="label-control" for="from">{{lang.label.dateFrom}}:</label>
                              <el-date-picker
                                v-model="models.dateFrom"
                                type="date"
                                format="dd/MM/yyyy"
                                id="dateFrom"
                                :picker-options="dateFromOptions"
                                :placeholder="lang.label.placeholder.date"
                              ></el-date-picker>
                              <span v-if="noToDateSelected" style="color: red">{{lang.label.selectStartDate}}</span>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group>
                              <label class="label-control" for="to">{{lang.label.dateTo}}:</label>
                              <el-date-picker
                                v-model="models.dateTo"
                                type="date"
                                format="dd/MM/yyyy"
                                id="dateTo"
                                :picker-options="dateToOptions"
                                :placeholder="lang.label.placeholder.date"
                              ></el-date-picker>
                              <span v-if="noFromDateSelected" style="color: red">{{lang.label.selectEndDate}}</span>
                            </b-form-group>
                          </div>
                          <div class="col-md-4 align-self-center">
                            <b-form-group class="mb-md-0">
                              <label class="label-control d-none d-md-block">&nbsp;</label>
                              <b-btn
                                type="submit"
                                variant="secondary"
                                class="mr-2"
                                @click="filter"
                              >{{lang.label.buttons.filter}}</b-btn>
                              <b-btn type="submit" variant="secondary" @click="reset">{{lang.label.buttons.reset}}</b-btn>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <hr class="mx--body my-0" />
        <div class="row mt-3">
          <div class="col-md-12">
            <b-tabs content-class="mt-3">
              <b-tab active>
                <template slot="title">
                  <span>{{lang.label.paymentsFrompatients}}</span>
                  <span class="pl-3 font-weight-bold">{{"R "+paymentDetails.patientPaymentTotal}}</span>
                </template>
                <div class="row" v-if="paymentDetails.patientPayment">
                  <div class="col-md-4" v-for="(patient, indexPatient) in paymentDetails.patientPayment" :key="indexPatient">
                    <b-card class="shadow-none tab-card" body-class="p-3">
                      <div class="row">
                        <div class="col-md-12">
                          <span class="d-block md-text">{{lang.label.scriptId}}: {{patient.scriptNo}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.dateTime}}: {{dateFormatWithTime(patient.paymentDate)}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.patientName}}: {{patient.patientName}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.totalAmount}}: R {{patient.totalAmount}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.myAmount}}: R {{patient.myAmount}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.adminCommission}}: R {{patient.adminCommission}}</span>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
                <div v-if="paymentDetails.patientPayment">
                  <span v-if="paymentDetails.patientPayment.length < 1">{{lang.label.noDataFound}}</span>
                </div>
              </b-tab>
              <b-tab>
                <template slot="title">
                  <span>{{lang.label.paymentsFromAdmin}}</span>
                  <span class="pl-3 font-weight-bold">{{"R "+paymentDetails.adminPaymentTotal}}</span>
                </template>
                <div class="row" v-if="paymentDetails.adminPayments">
                  <div class="col-md-4" v-for="(admin, indexAdmin) in paymentDetails.adminPayments" :key="indexAdmin">
                    <b-card class="shadow-none tab-card" body-class="p-3">
                      <div class="row">
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.date}}: {{dateFormat(admin.paymentDate)}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.paymentMode}}: {{admin.paymentMode}}</span>
                        </div>
                        <div class="col-md-12">
                          <span class="mt-2 d-block">{{lang.label.totalAmount}}: R {{admin.amount}}</span>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
                <div v-if="paymentDetails.adminPayments">
                  <span v-if="paymentDetails.adminPayments.length < 1">{{lang.label.noDataFound}}</span>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>



<script>
import jsondata from "../assets/json/data.json";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters({
      login: "login",
      loading: "loading",
    }),
    dateFrom(){
      return this.models.dateFrom;
    },
    dateTo(){
      return this.models.dateTo;
    }
  },
  watch: {
    dateFrom(val){
      this.disablingToDate = this.models.dateTo;
    },
    dateTo(val){
      this.disablingFromDate = this.models.dateFrom;
    }
  },
  data() {
    return {
      disablingFromDate: '',
      disablingToDate: '',
      noFromDateSelected: false,
      noToDateSelected: false,
      noDateSelected: false,
      data: jsondata,
      paymentDetails: {},
      lang: this.$lang.payment_summary,
      models: {
        dateFrom: moment().subtract(6, 'months'),
        dateTo: moment(),
      },
      fromDate:moment().subtract(6, 'months'),
      toDate: moment(),
      dateFromOptions: {
        disabledDate : this.disableFromDate
      },
      dateToOptions: {
        disabledDate : this.disableToDate
      },
    };
  },
  mounted(){
    this.getPaymentHistory(this.models.dateFrom,this.models.dateTo);
  },
  methods: {
    disableFromDate(date) {
          this.noDateSelected = false;
          this.noToDateSelected = false;
        if(this.models.dateTo  != null && this.models.dateTo  != ''){
          return ((date > this.models.dateTo || date > Date.now() ) ||  date < (moment().subtract(6, 'months')).subtract(1, 'day'));
        } else{
             return (date > Date.now() && date < moment);
        }
    },
    disableToDate(date) {
      this.noFromDateSelected = false;
      this.noDateSelected = false;
      return ( date < this.models.dateFrom || date > Date.now()||  date < (moment().subtract(6, 'months')).subtract(1, 'day'));
    },
    dateFormat(date){
      return moment(date).format("DD/MM/YYYY");
    },
    dateFormatWithTime(date){
      return moment(date).format("DD/MM/YYYY, HH:MM A");
    },
    filter(){
      if(this.models.dateTo && this.models.dateFrom){
        this.$store.commit('setLoading',true);
        this.fromDate = this.models.dateFrom;
        this.toDate = this.models.dateTo;
        this.getPaymentHistory(this.models.dateFrom,this.models.dateTo);
      }else{
        if(this.models.dateTo == null && this.models.dateFrom == null){
          this.noToDateSelected = true;
        }else if(this.models.dateTo == '' && this.models.dateFrom == ''){
          this.noToDateSelected = true;
        }else {
          if(this.models.dateTo){
            this.noToDateSelected = true;
          }
          if(this.models.dateFrom){
            this.noFromDateSelected = true;
          }
        }
      }
    },
    reset(){
      this.models = {
        dateFrom: "",
        dateTo: "",
      };
      /*this.fromDate = this.models.dateFrom;
      this.toDate = this.models.dateTo;*/
    },
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getPaymentHistory(from,to){
      let data = {
        "fromDate" : moment(from).format("YYYY-MM-DD"),
        "toDate" : moment(to).format("YYYY-MM-DD")
      };
      this.$store.dispatch('paymentHistory',data).then(value => {
        if(value.data){
          this.paymentDetails = value.data;
        }
      });
    },
    onSubmit() {
    }
  }
};
</script>
